<template>
  <div>
    <!-- 画像アップロード -->
    <el-form >
      <el-form-item label="電話番号" label-width="70">
        <el-input v-model="form.contact_tel" required  style="width: 200px;"/>
      </el-form-item>
      <el-form-item label="ファクス" label-width="70">
        <el-input v-model="form.contact_fax" required  style="width: 200px;"/>
      </el-form-item>
      <el-form-item label="メール" label-width="70">
        <el-input v-model="form.contact_mail" required  style="width: 200px;"/>
      </el-form-item>
      <el-form-item label="LINE" label-width="70">
        <el-input v-model="form.contact_line" required  style="width: 200px;"/>
      </el-form-item>
    </el-form>

    <el-divider />

    <!-- 日本語 & 英語 タイトルと内容 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <h3>日本語</h3>
        <el-form >
          <el-form-item label="営業時間">
            <el-input v-model="form.contact_time_ja" type="textarea" :rows="2" required />
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <h3>英語</h3>
        <el-form >
          <el-form-item label="Business Hours">
            <el-input v-model="form.contact_time_en" type="textarea" :rows="2" required />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-divider />

    <!-- 保存ボタン -->
    <el-button type="primary" @click="confirmSave">保存</el-button>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { supabase } from "@/supabase.js"; // Supabase 连接

export default {
  setup() {
    const form = ref({
      contact_tel: "",
      contact_fax: "",
      contact_mail: "",
      contact_time_ja: "",
      contact_time_en: "",
      contact_line:"",
    });

    // 📌 Supabase: 获取 `home_info` 数据
    const fetchData = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select("contact_tel, contact_fax, contact_mail, contact_time_ja, contact_time_en,contact_line")
        .eq("id", "home_info")
        .single();

      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        form.value = data;
      }
    };


    // 📌 保存数据
    const saveData = async () => {
      if (!form.value.contact_tel
      || !form.value.contact_fax
      || !form.value.contact_mail
      || !form.value.contact_time_ja
      || !form.value.contact_time_en
      || !form.value.contact_line ) {
        ElMessage.error("全ての項目を入力してください。");
        return;
      }

      // 更新 `home_info` 表
      const { error } = await supabase
        .from("home_info")
        .update({
          contact_tel: form.value.contact_tel,
          contact_fax: form.value.contact_fax,
          contact_mail: form.value.contact_mail,
          contact_time_ja: form.value.contact_time_ja,
          contact_time_en: form.value.contact_time_en,
          contact_line: form.value.contact_line,
        })
        .eq("id", "home_info");

      if (error) {
        console.error("データ保存エラー:", error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
      }
    };

    // 📌 确认保存对话框
    const confirmSave = () => {
      ElMessageBox.confirm("この内容で保存しますか？", "確認", {
        confirmButtonText: "保存",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          saveData();
        })
        .catch(() => {
          ElMessage.info("保存をキャンセルしました。");
        });
    };

    onMounted(fetchData);

    return {
      form,
      confirmSave,

    };
  },
};
</script>
<style lang="stylus" scoped>
.uploaded-image {
  height: 150px; /* 只控制高度 */
  width: auto; /* 宽度自适应 */
  object-fit: contain; /* 保持原比例，不裁剪 */
  border-radius: 8px; /* 圆角 */
  display: block;
  max-width: 100%; /* 防止超出父容器 */
}
:deep(.el-upload--picture-card) {
    --el-upload-picture-card-size: 148px;
    align-items: center;
    background-color: var(--el-fill-color-lighter);
    border: 1px dashed var(--el-border-color-darker);
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: var(--el-upload-picture-card-size);
    justify-content: center;
    vertical-align: top;
    width: 300px;
}
</style>
